import type { QueryClient } from '@tanstack/react-query';
import { notFound, redirect } from '@tanstack/react-router';
import { getVisualizationViewsQueryOptions } from '@/lib/queries/view/useVisualizationsView';
import { getLastVisitedView } from './lastVisitedVisualizationView';

export async function redirectToFirstLoopVisualizationView({
  org,
  queryClient,
  loopId,
}: {
  org: string;
  queryClient: QueryClient;
  loopId: number;
}): Promise<void> {
  if (!loopId) throw notFound();

  const views = await queryClient.ensureQueryData(
    getVisualizationViewsQueryOptions({
      loopId,
    }),
  );

  const lastVisitedViewId = getLastVisitedView(loopId);
  const targetView =
    (lastVisitedViewId ? views.find((v) => v.viewId === lastVisitedViewId) : undefined) ?? views[0];

  if (targetView) {
    throw redirect({
      to: `/org/$org/loop/$loopId/visualizations/view/$viewId`,
      params: { org, loopId, viewId: targetView.viewId },
      replace: true,
    });
  }

  throw redirect({
    to: '/org/$org/loop/$loopId/visualizations/items',
    params: { org, loopId },
    replace: true,
  });
}
